export const findObjectByFIO = (items, searchString) => {
  return items.find(item => item.FIO === searchString) || null;
};

export const allStatisticsUsers = (users, statisticsByMonth) => {
  const classObj = {
    1: 0,
    2: 0,
    3: 0,
    4: 0,
    5: 0,
    6: 0,
    7: 0,
    8: 0,
    9: 0,
    10: 0,
    11: 0,
    OtherClasses: 0,
  };

  const currentYear = new Date().getFullYear().toString();
  const monthCounts = statisticsByMonth[currentYear] || {
    January: 0,
    February: 0,
    March: 0,
    April: 0,
    May: 0,
    June: 0,
    July: 0,
    August: 0,
    September: 0,
    October: 0,
    November: 0,
    December: 0,
  };

  users.forEach(user => {
    const classStudent = user.classStudent;

    if (classStudent && classStudent >= 1 && classStudent <= 11) {
      classObj[classStudent]++;
    } else {
      classObj['OtherClasses']++;
    }

    const month = user.month;
    if (month in monthCounts) {
      monthCounts[month]++;
    }
  });

  return { classObj, monthObj: monthCounts };
};

export const calculateHeight = (currentValue, maxValue = 60) => {
  const heightInPercent = (currentValue / maxValue) * 100;
  return Math.round(heightInPercent);
};
